const DEFAULT_URL_BASE = "https://placeholder.test";

/** Domains that should receive the memberUuid query parameter on links. */
export const INTERNAL_SERVICE_DOMAINS = ["help.indahash.com"];

export function isInternalServiceUrl(
  url: string,
  baseUrl = DEFAULT_URL_BASE,
): boolean {
  if (!url) return false;

  try {
    const parsed = new URL(url, baseUrl);
    return INTERNAL_SERVICE_DOMAINS.some((domain) =>
      parsed.hostname.includes(domain),
    );
  } catch {
    return false;
  }
}

/**
 * Append query params to URLs pointing to the knowledge base so that
 * Chatwoot KB can identify the user and render the embedded layout.
 */
export function appendMemberUuidToUrl(
  url: string,
  memberUuid: string | null,
  baseUrl = DEFAULT_URL_BASE,
): string {
  if (!url) return url;

  try {
    const parsed = new URL(url, baseUrl);
    if (
      INTERNAL_SERVICE_DOMAINS.some((domain) =>
        parsed.hostname.includes(domain),
      )
    ) {
      if (memberUuid) {
        parsed.searchParams.set("memberUuid", memberUuid);
      }

      parsed.searchParams.set("show_plain_layout", "true");
      return parsed.toString();
    }
  } catch {
    // If URL parsing fails, return the original URL unchanged.
  }

  return url;
}
